import { Modal } from "antd";
import { notify } from "@/shared/utils/notify";
import { AlertTriangle } from "lucide-react";

import {
  bannersChangeModalState,
  deleteBanner,
  refreshTableBanners,
  setBannersForUpdate,
  setIsBannersForUpdate,
} from "../../../redux";
import { DataBanner } from "../../../redux/@types";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { useBanners } from "./useBanners";

const { confirm } = Modal;

export const useTableBanners = () => {
  const dispatch = useAppDispatch();
  const { tableProps } = useBanners();

  const changeBannersForUpdate = (user: DataBanner) => {
    dispatch(setIsBannersForUpdate(true));
    dispatch(setBannersForUpdate(user));
    dispatch(bannersChangeModalState());
  };

  const showDeleteConfirm = (valId: number, _val: string) => {
    confirm({
      title: (
        <div style={{ fontSize: "18px", fontWeight: 600, color: "#2d3748", marginBottom: "8px" }}>
          ¿Eliminar banner?
        </div>
      ),
      icon: (
        <div style={{ 
          width: "48px", 
          height: "48px", 
          borderRadius: "12px", 
          backgroundColor: "#fff3e6",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "16px"
        }}>
          <AlertTriangle size={24} color="#ff6b00" />
        </div>
      ),
      content: (
        <div style={{ color: "#718096", fontSize: "14px", lineHeight: "1.6" }}>
          Estás a punto de eliminar el banner con ID: <strong style={{ color: "#2d3748" }}>{valId}</strong>.
          <br /><br />
          Esta acción no se puede deshacer. ¿Deseas continuar?
        </div>
      ),
      okText: "Sí, eliminar",
      okType: "danger",
      cancelText: "Cancelar",
      keyboard: true,
      maskClosable: true,
      centered: true,
      okButtonProps: {
        style: {
          borderRadius: "8px",
          height: "40px",
          fontWeight: 500,
          padding: "0 24px",
        }
      },
      cancelButtonProps: {
        style: {
          borderRadius: "8px",
          height: "40px",
          fontWeight: 500,
          padding: "0 24px",
        }
      },
      async onOk() {
        await deleteBanner(valId)
          .then(() => {
            dispatch(refreshTableBanners(true));
            notify.success(`Banner eliminado correctamente`);
            tableProps?.refresh();
          })
          .catch((err) => {
            console.log({ err });
            notify.error(err.message);
          });
      },
      onCancel() {},
    });
  };

  return {
    //state
    //methods
    //functions
    changeBannersForUpdate,
    showDeleteConfirm,
  };
};
